import { useMutation } from '@tanstack/react-query';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { downloadBlob } from '@common/utils/downloadBlob';
import { apiClient } from '@config/server/apiClient';
import { leadsEndpoints } from '@config/server/apiEndpoints';

/**
 * Export leads request parameters
 */
export interface ExportLeadsParams {
	leadIds?: string[];
}

/**
 * API function to export leads as CSV
 * Downloads the file to the user's machine
 */
export const exportLeads = async (
	servicesProviderId: string,
	params: ExportLeadsParams,
): Promise<void> => {
	const { leadIds } = params;

	// Use apiClient to get blob response
	const blob = await apiClient.postBlob(leadsEndpoints.export(servicesProviderId), {
		leadIds,
	});

	downloadBlob(blob, 'leads.csv');
};

/**
 * Hook for exporting leads as CSV
 */
export const useExportLeads = () => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useMutation({
		mutationFn: async (params: ExportLeadsParams) => {
			if (!servicesProviderId) {
				throw new Error('Cannot export leads without services provider ID');
			}
			return exportLeads(servicesProviderId, params);
		},
	});
};
